// extracted by mini-css-extract-plugin
module.exports = {"Page_Switcher_Wrap":"PageSwitcher_Page_Switcher_Wrap__2nQkL","Page_Switcher_Input":"PageSwitcher_Page_Switcher_Input__6Xf5w"};